import basePath from "base_path";

import ActionTypes, {ClientContextActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ClientContext} from "common/types/client_context";

export type ClientContextsFetchAction = {
  type: ClientContextActionTypes["CLIENT_CONTEXTS_FETCH"]["SUCCESS"];
  payload: ClientContext[];
};

export default function fetchClientContexts(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CLIENT_CONTEXTS_FETCH,
    (organisationId: OrganisationId) => {
      return requestor
        .get(`${basePath}/organisation/${organisationId}/client_context`, {
          withCredentials: true,
        })
        .then(response => response.data);
    },
  );
}
